import React from 'react'
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout'

const FormField = () => {
  return (
      <>
          <PageHeaderLayout headerTitle={'Form fields'}>
                {/* <PermissionGuard feature='service' permission='canCreate'>
                <Button variant='contained' size='small'
                    // onClick={() => modalOpen({},'add')} 
                    onClick={() => navigate('/admin/service/0')}
                    sx={{ fontSize: { xs: '.5rem', sm: '.75rem' } }} endIcon={<AddCircleIcon />}
                >
                    Add Service
                </Button>
                </PermissionGuard> */}
            </PageHeaderLayout>
      </>
  )
}

export default FormField